const STORAGE_TOKEN_KEY = "refreshToken";
const STORAGE_EVENT_FILTERS_KEY = "budoevents_event_filters";

export class Storage {
    static mode = "web";

    static init() {
        Storage.mode = "web";
    }

    static async get(key) {
        Storage.checkKey(key);

        return Storage.deserialize(localStorage.getItem(key));
    }

    static async set(key, value) {
        Storage.checkKey(key);
        localStorage.setItem(key, Storage.serialize(value));

        return true;
    }

    static async remove(key) {
        Storage.checkKey(key);
        localStorage.removeItem(key);

        return true;
    }

    static async setStorageToken(refreshToken) {
        localStorage.setItem(STORAGE_TOKEN_KEY, Storage.serialize(refreshToken));

        return true;
    }

    static async getStorageToken() {
        return Storage.deserialize(localStorage.getItem(STORAGE_TOKEN_KEY));
    }

    static async removeStorageToken() {
        localStorage.removeItem(STORAGE_TOKEN_KEY);

        return true;
    }

    static async setEventFilters(filters) {
        return Storage.set(STORAGE_EVENT_FILTERS_KEY, filters);
    }

    static async getEventFilters() {
        return Storage.get(STORAGE_EVENT_FILTERS_KEY);
    }

    static async removeEventFilters() {
        return Storage.remove(STORAGE_EVENT_FILTERS_KEY);
    }

    static async setMapState(idMap, value) {
        return Storage.set(Storage.getMapStateKey(idMap), value);
    }

    static async getMapState(idMap) {
        return Storage.get(Storage.getMapStateKey(idMap));
    }

    static async removeMapState(idMap) {
        return Storage.remove(Storage.getMapStateKey(idMap));
    }

    static getMapStateKey(idMap) {
        if (idMap === null || typeof idMap === "undefined" || idMap === "") {
            throw new Error("Map storage requires a valid id_map");
        }

        return `budoevents_map#${idMap}`;
    }

    static checkKey(key) {
        if (!key || typeof key !== "string") {
            throw new Error("Storage key must be a non-empty string");
        }
    }

    static serialize(value) {
        if (typeof value === "string") {
            return value;
        }

        return JSON.stringify(value);
    }

    static deserialize(value) {
        if (value === null || typeof value === "undefined") {
            return null;
        }

        try {
            return JSON.parse(value);
        } catch (error) {
            return value;
        }
    }
}
